import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";
import { useSetProductChangeCall } from "../../services";

const Views = ({ viewActionData, sessionId, collectionActionData }) => {
  const { mutate: changeViewCall } = useSetProductChangeCall();

  const interactions = viewActionData?.[0]?.interactions || [];
  const defaultInteraction = interactions?.find(
    (interaction) => interaction?.is_default
  );

  const [selectedInteraction, setSelectedInteraction] = useState(
    defaultInteraction ? defaultInteraction?.interaction_id : null
  );

  useEffect(() => {
    if (defaultInteraction) {
      const item = collectionActionData?.items?.[0];
      if (!item) {
        console.error("No item found in collectionActionData");
        return;
      }

      const viewPayload = {
        session_id: sessionId,
        message: {
          type: "run_interaction",
          message: {
            item_id: item.item_id,
            product_key: item.product.product_key,
            interaction_id: defaultInteraction.interaction_id,
          },
        },
      };

      changeViewCall(viewPayload);
    }
  }, [defaultInteraction, sessionId, collectionActionData]);

  const handleViewChange = (interaction) => {
    setSelectedInteraction(interaction.interaction_id);

    const item = collectionActionData?.items?.[0];
    if (!item) {
      console.error("No item found in collectionActionData");
      return;
    }

    const viewPayload = {
      session_id: sessionId,
      message: {
        type: "run_interaction",
        message: {
          item_id: item.item_id,
          product_key: item.product.product_key,
          interaction_id: interaction.interaction_id,
        },
      },
    };

    changeViewCall(viewPayload);
  };

  return (
    <Box
      style={{
        height: "36px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "row",
          borderRadius: "8px",
          backgroundColor: "#f0f0f0",
          overflow: "hidden",
          padding: "1px 2px",
        }}
      >
        {interactions?.map((interaction) => {
          const largeIcon = interaction?.interaction_icons.find(
            (icon) => icon.file_type === "L"
          );

          return (
            <Tooltip
              key={interaction?.interaction_id}
              title={interaction?.interaction_name}
            >
              <IconButton
                key={interaction.interaction_id}
                onClick={() => handleViewChange(interaction)}
                sx={{
                  transition: "background-color 0.3s ease",
                  borderRadius: "8px",
                  backgroundColor:
                    selectedInteraction === interaction?.interaction_id
                      ? "white"
                      : "transparent",
                  color:
                    selectedInteraction === interaction?.interaction_id
                      ? "#fff"
                      : "#000",
                  "&:hover": {
                    backgroundColor:
                      selectedInteraction === interaction?.interaction_id
                        ? "white"
                        : "#e0e0e0",
                  },
                }}
              >
                <img
                  src={largeIcon?.path}
                  alt={interaction?.interaction_name}
                  style={{
                    width: 20,
                    height: 20,
                    filter:
                      selectedInteraction === interaction?.interaction_id
                        ? "none"
                        : "grayscale(100%)",
                    transition: "filter 0.3s ease",
                  }}
                />
              </IconButton>
            </Tooltip>
          );
        })}
      </Paper>
    </Box>
  );
};

export default Views;
